export default __webpack_public_path__ + "static/media/1.d3c2046f.png";